module.exports = __webpack_public_path__ + "static/media/banner2.008c7f54.jpg";